export function getImageTypeBySignature(signature) {
  if (String(signature).match(/^FFD8FF/)) return "image/jpeg";
  if (String(signature).match(/^89504E470D0A1A0A/)) return "image/png";
  if (String(signature).match(/^474946383761/)) return "image/gif";
  if (String(signature).match(/^474946383961/)) return "image/gif";
  if (String(signature).match(/3C73766720/)) return "image/svg+xml";
  return "Unknown";
}

export function getSignatureFromBase64Data(data) {
  const content = atob(data);
  return content.substring(0, 100).split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("").toUpperCase();
}

export async function getImageMimeTypeOfBlob(blob) {
  let mimeType = blob.type;
  try {
    if (!String(mimeType).match(/^image/)) {
      // mimeType aus der signatur der Datei ermitteln
      mimeType = await blob.arrayBuffer()
        .then(array => {
          return new Uint8Array(array).subarray(0, 100);
        })
        .then(start => {
          const signature = Array.from(start).map(x => {
            const hex = (x).toString(16).padStart(2,"0").toUpperCase();
            return hex;
          }).join("");
          return getImageTypeBySignature(signature);
        }).catch(e => {
          console.log(e);
        });
    }
  } catch (e) {
    console.log(e);
  }
  return mimeType;
}
